export default [
  {
    path: "/procurement-audit/audit-plans",
    name: "audit-plans",
    meta: { title: "Audit plans", authRequired: true },
    privileges: [
      'VIEW_PLAN',
      'ADD_SHEDULE_ITEM',
      'EDIT_SHEDULE_ITEM',
      'DELETE_SHEDULE_ITEM',
    ],
    component: () => import("../views/procurement-audit/audit-plans"),
  },
  {
    path: "/procurement-audit/audit-execution",
    name: "audit-execution",
    meta: { title: "Audit execution", authRequired: true },
    component: () => import("../views/procurement-audit/audit-execution.vue"),
  },
  {
    path: "/procurement-audit/debrief-notes",
    name: "debrief-notes",
    meta: { title: "Debrief notes", authRequired: true },
    component: () => import("../views/procurement-audit/debrief-notes"),
  },
  {
    path: "/procurement-audit/audit-reports",
    name: "audit-reports",
    meta: { title: "Audit reports", authRequired: true },
    component: () => import("../views/procurement-audit/audit-reports"),
  },
  {
    path: "/procurement-audit/create-audit-plan",
    name: "create-audit-plan",
    meta: { title: "Create audit plan", authRequired: true },
    component: () => import("../views/procurement-audit/create-audit-plan"),
  },
  {
    path: "/procurement-audit/update-audit-plan",
    name: "update-audit-plan",
    meta: { title: "Update audit plan", authRequired: true },
    component: () => import("../views/procurement-audit/update-audit-plan"),
  },
  {
    path: "/procurement-audit/view-audit-plan",
    name: "view-audit-plan",
    meta: { title: "View audit plan", authRequired: true },
    component: () => import("../views/procurement-audit/view-audit-plan"),
  },
  {
    path: "/procurement-audit/audit-findings",
    name: "audit-findings",
    meta: { title: "Audit execution - record audit findings", authRequired: true },
    component: () => import("../views/procurement-audit/audit-findings"),
  },
  {
    path: "/procurement-audit/view-audit-findings",
    name: "view-audit-findings",
    meta: { title: "Audit reporting - view audit findings", authRequired: true },
    component: () => import("../views/procurement-audit/view-audit-findings"),
  },
  {
    path: "/procurement-audit/capacity-assessment-sections",
    name: "capacity-assessment-sections",
    meta: { title: "Audit Tools - Capacity assessment form sections", authRequired: true },
    component: () => import("../views/procurement-audit/audit-tools-setup/capacity-assessment-sections"),
  },
]